var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifierSearch = function SvgMagnifierSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "m20.119 19-3.28-3.22a7.86 7.86 0 0 0 1.82-5.05 7.93 7.93 0 1 0-7.93 7.93 7.86 7.86 0 0 0 5.11-1.88l3.24 3.24a.75.75 0 0 0 1.06 0 .75.75 0 0 0-.02-1.02m-15.78-8.29a6.43 6.43 0 1 1 12.86 0 6.43 6.43 0 0 1-12.86 0"
  })));
};
export default SvgMagnifierSearch;